import FeatureGates from '@atlaskit/feature-gate-js-client';

import SentryLogger from '@app/sentry';

import { featureGateKeys, type FeatureGateValue } from './feature-gate-keys';

const developmentFeatureGateOverrides: Partial<
  Record<FeatureGateValue, boolean>
> = {
  [featureGateKeys.aiImpactAndContextTags]: true,
};

/**
 * Checks whether a feature gate is enabled.
 * Delegates to FeatureGates.checkGate and returns false on error.
 *
 * @param key - A feature gate key from featureGateKeys
 * @returns true if the gate is enabled, false otherwise
 */
export function fg(key: FeatureGateValue): boolean {
  if (
    process.env.NODE_ENV === 'development' &&
    key in developmentFeatureGateOverrides
  ) {
    return developmentFeatureGateOverrides[key] === true;
  }

  try {
    return FeatureGates.checkGate(key);
  } catch (e) {
    SentryLogger.warn(`[FeatureGates] Failed to check gate "${key}": ${e}`);
    return false;
  }
}
